import Vue from 'vue';
import Storage from 'vue-ls';
import VueClipboard from 'vue-clipboard2';
import App from './App.vue';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import store from './store';
import router from './router';

Vue.config.productionTip = false;

Vue.use(Storage, {
  namespace: 'mkt_',
  name: 'ls',
  storage: 'local',
});
Vue.use(ElementUI);
Vue.use(VueClipboard);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
